import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, isAuthenticated }) {
  // If not authenticated, redirect to landing page
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  // If authenticated, render the protected content
  return children;
}
